import { d as defineCustomElement } from '../chunks/vidstack-s5pw8Cb6.js';
import { a as MediaPlayerElement, M as MediaProviderElement } from '../chunks/vidstack-w_ZalepA.js';
import '../chunks/vidstack-sKeoTFgw.js';
import '../chunks/vidstack-8n__KtFR.js';
import '../chunks/vidstack-XmoYV57V.js';
import '../chunks/vidstack-UV9ceSS6.js';
import '../chunks/vidstack-PYaZQCX6.js';
import '../chunks/vidstack-yqTzryo_.js';
import '../chunks/vidstack-XcK8ubY-.js';

defineCustomElement(MediaPlayerElement);
defineCustomElement(MediaProviderElement);
